<template>
  <div class="col-sm-6 col-md-4 col-lg-3 col-6">
    <div
      class="folder"
      :class="{'folder--hover': isHover}"
      v-on="hoverHandlers"
      @click.stop="$emit('click')"
    >
      <!-- Image -->
      <img
        v-if="image"
        class="folder__image"
        :src="resizedImage"
        :alt="innerTitle"
      >
      <!-- <img
      v-if="!image"
      class="folder__empty"
      src="/img/blankFolder.png"
      :alt="innerTitle"
    > -->
      <div
        v-if="!image"
        class="folder__empty d-flex"
        :style="`${isAdmin ? 'background: #FAF9F7 ' : 'background: #F5EFEB' }`"
      >
        <base-icon
          style=" align-self: center;"
          icon="folderMono"
        />
      </div>

      <!-- /Image -->

      <!-- Title and Edit -->
      <div
        class="folder__title"
        @click.stop="handleClick"
        @dblclick.stop="handleDblClick"
      >
        <template v-if="!editMode">
          {{ innerTitle || defaultTitle }}
        </template>
        <input
          v-show="editMode"
          ref="input"
          v-model="innerTitle"
          class="folder__input"
          type="text"
          @keydown.enter="$event.target.blur()"
          @blur="stopEditing"
        >
      </div>
      <!-- / Title and edit -->
      <span
        v-if="canDelete"
        class="folder__delete"
        @click.stop="$emit('delete')"
      >
        <base-icon
          class="folder__delete__icon"
          icon="cancel"
        />
      </span>
    </div>
  </div>
</template>

<script>
import Hoverable from '@/components/mixins/hoverable';

export default {
  name: 'AlbumFolder',
  mixins: [Hoverable],
  props: {
    canEdit: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    folderId: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      editMode: false,
      singleClicked: false, // Required for single and doubleclick (Only in this component)
      innerTitle: '', // we are working with this title in the component
      defaultTitle: '(Folder name)',
    };
  },
  computed: {
    resizedImage() {
      const width = 211 * 2;
      const height = 148 * 2;
      return `${this.image}?w=${width}&h=${height}&fit=crop&fill=solid&?fill-color=FFFFFF`;
    },
    isAdmin() {
      return this.$store.state.account.isAdminMode;
    },
  },
  watch: {
    value: {
      handler() {
        this.innerTitle = this.value;
      },
      immediate: true,
    },
    editMode: {
      handler() {
        if (this.innerTitle.trim() === '') this.innerTitle = 'New Album';
      },
    },
  },
  methods: {
    focus() {
      this.editMode = true;
      this.$nextTick().then(() => {
        this.$refs.input.focus();
      });
    },
    handleClick() {
      const delay = 500; // Delay between a single click and a doubleclick
      this.singleClicked = true;
      setTimeout(() => {
        if (this.singleClicked) {
          // this.$emit('click');
          this.singleClicked = false;
        }
      }, delay);
    },
    handleDblClick() {
      this.singleClicked = false;
      this.startEditing();
    },
    stopEditing() {
      const newName = this.innerTitle.trim();
      if (newName !== '') {
        this.$emit('title-change', { name: newName, folderPk: this.folderId });
      } else {
        this.$emit('title-change', { name: 'New Album', folderPk: this.folderId });
      }
      this.editMode = false;
    },
    startEditing() {
      if (!this.canEdit) {
        return;
      }
      this.editMode = true;
      this.$nextTick().then(() => {
        this.$refs.input.focus();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.folder{
  background-color: white;
  height: 210px;
  position: relative;
  cursor: pointer;
  padding-right: 10px;
  padding-bottom: 30px;

  &__empty{
    // background-color: $bg-dashboard;
    height: 180px;
    width: 100%;
    min-width: 200px;
    justify-content: center;
  }
  &__image{
    background-color: $gray-light;
    height: 180px;
    width: 100%;
    display: inline-block;
    object-fit: cover;
    transition: opacity 0.2s;
    border-radius: 4px;
  }
  &--hover &__image{
    opacity: 0.8;
  }
  &__title{
      cursor: auto;
      font-size: 0.875rem;
      font-family: $font-family-sans-serif-light;
      // border: 1px solid #D4D4D4;
      height: 27px;
      padding-top: 8px;
      display: block;
      justify-content: center;
      align-items: center;
      background-color: white;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      text-align: center;

  }
  &__delete{
    position: absolute;
    top: 1rem;
    right: 1rem;
    opacity: 0;
    z-index: 2;
    transition: all 0.2s;
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
      opacity: 1;
    }
    &__icon{
      background-color: $gray-light;
      border-radius: 5px;
      padding: 0.5rem;
    }
  }
  &--hover &__delete{
    opacity: 1;
  }
  &__input{
    width: 100%;
    text-align: center;
    border: none;
    background-color: white;
  }
  &__input::first-line{
    background-color: $bg-dashboard;
  }
  &__input:focus{
    outline: none;
  }
}
</style>
